import { computeStdoutId } from "./common";
export var ActionsTypes;
(function (ActionsTypes) {
    ActionsTypes["SET_STDOUT"] = "STDOUT/SET";
    ActionsTypes["FETCH_STDOUT"] = "STDOUT/FETCH_START";
    ActionsTypes["FETCH_STDOUT_STOP"] = "STDOUT/FETCH_STOP";
    ActionsTypes["REFRESH_STDOUT"] = "REFRESH_STDOUT";
    ActionsTypes["ADD_STDOUT_CHUNK"] = "STDOUT/ADD_STDOUT_CHUNK";
    ActionsTypes["CLEAN_STDOUT"] = "STDOUT/CLEAN_STDOUT";
})(ActionsTypes || (ActionsTypes = {}));
export const cleanStdout = (config) => {
    const { scenario, program, mode, workspace } = config;
    const id = computeStdoutId(scenario, workspace, program, mode);
    return { type: ActionsTypes.CLEAN_STDOUT, id };
};
export const refreshStdout = (action) => {
    return {
        type: ActionsTypes.REFRESH_STDOUT,
        payload: action.payload
    };
};
export const addStdoutChunk = (config, payload, isStart = true, updated = true) => {
    const { scenario, workspace, program, mode } = config;
    const id = computeStdoutId(scenario, workspace, program, mode);
    return {
        type: ActionsTypes.ADD_STDOUT_CHUNK,
        payload: Object.assign(Object.assign({}, payload), { isStart, updated }),
        id
    };
};
export const fetchStdout = (payload) => {
    return {
        payload,
        type: ActionsTypes.FETCH_STDOUT
    };
};
export const stopFetchingStdout = (payload) => ({
    type: ActionsTypes.FETCH_STDOUT_STOP,
    payload
});
//# sourceMappingURL=actions.js.map